import { useDebounce } from './useDebounce';

/**
 * Debounced search value that is also trimmed of surrounding whitespace.
 *
 * Use for server-side table search inputs: a whitespace-only query collapses
 * to '' (falsy → treat as "no filter"), and «  cat  » is sent to the API as
 * «cat» instead of a value that won't match. The raw input state stays
 * untrimmed so typing (and trailing spaces mid-word) is never disrupted.
 */
export function useDebouncedSearch(value: string, delay: number = 500): string {
  return useDebounce(value, delay).trim();
}
